<template>
  <div class="trainer-frequency-chart trafrechrt">
    <div
      v-if="hasFrequencyChart"
      class="trafrechrt_chart-container"
    >
      <StudyFrequencyChart
        :skeleton="skeleton"
        :actions="l_actions"
        :hasFullscreen="false"
        :hasLegend="false"
        :freKey="freKey"
        :readOnly="true"
        :hasEv="hasEv"
        :showBetsIn="showBetsIn"
      />
    </div>

    <HorizontalChart
      v-if="hasHorizontalChart"
      :limitLegendTo="99"
      :hasLegend="true"
      :legendRaiseFirst="true"
      :skeleton="skeleton"
      :useHex="true"
      freKey="frequency"
      style="--chart-height: 1em"
      :solution="l_actions"
      :style="horChartStyle"
      :class="horChartClass"
      :readOnly="true"
    />
  </div>
</template>

<script>
import StudyFrequencyChart from '@/components/Charts/BarChart/StudyFrequencyChart'
import HorizontalChart from '@/components/Charts/HorizontalChart/HorizontalChart'

export default {
  name: 'TrainerFrequencyCharts',
  components: {
    StudyFrequencyChart,
    // StudyGraphSolutions,
    // StudyPieChart,
    HorizontalChart,
  },
  props: {
    actions: Array,
    hasLegend: { type: Boolean, default: true },
    skeleton: Boolean,
    legendRaiseFirst: { type: Boolean, default: true },
    hasEv: { type: Boolean, default: true },

    hasFrequencyChart: Boolean,
    hasHorizontalChart: Boolean,

    horChartClass: { default: () => 'graph-centered' },
    horChartStyle: { default: () => '--chart-height: 1rem' },
    // freqChartStyle: { default: () => '--freq-chart-height: 8em' },
    // limitLegendTo: Boolean,

    freKey: { default: () => '' },
    grouping: { default: () => 'swv_grouping_none' },
    // freKey: { default: () => 'total_frequency' },
    // freKey: { default: () => 'frequency' },
  },
  data() {
    return {}
  },

  computed: {
    l_actions() {
      let res = this.actions
      res = JSON.parse(JSON.stringify(res)).reverse()
      // console.log(res, 'dddddd')
      return res
    },
    showBetsIn() {
      return this.$store.getters.show_bets_in
    },
  },
}
</script>
<style lang="scss" scoped>
.trafrechrt {
  // flex: 1;
  width: 100%;
  // height: 8rem;
  // height: ;
  &_chart-container {
    --freq-chart-height: 8em;
    // --height-chart: 5em;
    position: relative;
    width: 100%;
    height: var(--freq-chart-height);
  }
}
</style>
